import Swiper from "swiper";
export function dirScroll(n) {
    let e = $(window).scrollTop();
    $(window).on("scroll", throttle(() => {
        const t = $(window).scrollTop();
        "function" == typeof n.scroll ? n.scroll(t) : console.error("funcs.scroll 不是函数"),
            t > e ? "function" == typeof n.down ? n.down(t) : console.error("funcs.down 不是函数") : "function" == typeof n.up ? n.up(t) : console.error("funcs.up 不是函数"),
            e = t
    }
        , 50, 1))
}
export function swiperTab(n, e) {
    const { nav: t = {}, con: o = {} } = e;
    let i = 500;
    const s = setSwiper(`${n} .con-swiper`, {
        speed: i,
        autoplay: !1,
        ...o
    })
        , l = setSwiper(`${n} .nav-swiper`, {
            ...t,
            speed: i,
            autoplay: !1,
            slidesPerView: "auto",
            on: {
                slideChangeTransitionStart(n) {
                    const e = n.realIndex;
                    if (0 !== s.length)
                        for (let n of s)
                            n.slideTo(e);
                    else
                        s.slideTo(e)
                }
            }
        });
    return {
        conSwiper: s,
        navSwiper: l
    }
}
export function hoverOn(n, e) {
    const t = $(n)
        , o = $(e);
    t.eq(0).addClass("on"),
        o.eq(0).addClass("on"),
        t.hover(function () {
            const n = $(this)
                , e = n.index();
            n.hasClass("on") || (n.addClass("on").siblings().removeClass("on"),
                o.eq(e).addClass("on").siblings().removeClass("on"))
        })
}
function scrollPosition() {
    const n = $(".scroll-x");
    if (0 !== n.length) {
        const e = n.find(".on")
            , t = e.position().left;
        n.scrollLeft(t - 50)
    }
}

function swiperVideo(n) {
    const e = n.slides[n.realIndex]
        , t = $(e).find("video");
    0 !== t.length ? (t[0].play(),
        n.autoplay.stop(),
        t.on("ended", () => {
            n.slideNext(),
                n.autoplay.start()
        }
        )) : n.autoplay.start()
}
export function setSwiper(n, e) {
    let t = e || {};
    n = n || ".swiper";
    let o = {
        direction: "horizontal",
        slideActiveClass: "active",
        speed: 1e3,
        delay: 4e3,
        loop: !1,
        autoplay: !0,
        autoVideoPlay: !1,
        observer: !0,
        observeParents: !0,
        observeSlideChildren: !0,
        stopOnLastSlide: !1,
        disableOnInteraction: !1,
        normalizeSlideIndex: !1,
        slideToClickedSlide: !0,
        effect: "slide",
        fadeEffect: {
            crossFade: !0
        },
        paginationEl: ".pagination",
        paginationType: "bullets",
        prevEl: `${n} .prev`,
        nextEl: `${n} .next`,
        scrollbar: ".scrollbar",
        noSwipingClass: "stop",
        mousewheel: !1,
        on: {}
    };
    return o = {
        ...o,
        ...t
    },
        o.autoplay ? o.autoplay = {
            delay: o.delay,
            stopOnLastSlide: o.stopOnLastSlide,
            disableOnInteraction: o.disableOnInteraction
        } : o.autoplay = !1,
        $(window).width() < 980 && (o = {
            ...o,
            ...o.m
        }),
        new Swiper(n, {
            pagination: {
                el: o.paginationEl,
                type: o.paginationType,
                bulletElement: o.paginationBulletElement || "div",
                dynamicBullets: o.paginationDynamicBullets || !1,
                dynamicMainBullets: o.paginationDynamicMainBullets || 1,
                clickable: o.paginationClickable || !0,
                renderBullet: o.paginationRenderBullet || null,
                bulletClass: o.paginationBulletClass || "bullet",
                bulletActiveClass: o.paginationBulletActiveClass || "on"
            },
            navigation: {
                nextEl: o.nextEl,
                prevEl: o.prevEl
            },
            scrollbar: {
                el: o.scrollbar
            },
            ...o,
            on: {
                init() {
                    o.autoVideoPlay && swiperVideo(this);
                    const n = o.on || {}
                        , e = n.init || null;
                    "function" == typeof e && e(this)
                },
                slideChangeTransitionEnd() {
                    o.autoVideoPlay && swiperVideo(this);
                    const n = o.on || {}
                        , e = n.slideChangeTransitionEnd || null;
                    "function" == typeof e && e(this)
                },
                ...o.on
            }
        })
}
function setTabs(n, e) {
    const t = $(n).find(".tab")
        , o = $(e).find(".item");
    t.eq(0).addClass("on"),
        o.eq(0).addClass("on"),
        t.on("click", function () {
            const n = $(this)
                , e = n.index();
            n.addClass("on").siblings().removeClass("on"),
                o.eq(e).addClass("on").siblings().removeClass("on")
        })
}
function imgView(n) {
    const e = $(n)
        , t = e.find("img");
    let o = {};
    t.each((n, e) => {
        const t = $(e).attr("src");
        o = {
            ...o,
            [n]: {
                src: t
            }
        }
    }
    );
    const i = '\n\t\t<div class="pop on animated fadeIn img-view" id="viewImg">\n\t\t\t<div class="close-btn">\n\t\t\t\t<i class="iconfont icon-close5"></i>\n\t\t\t</div>\n\t\t\t<img />\n\t\t</div>\n\t';
    e.on("click", function () {
        const n = $(this)
            , e = n.index()
            , t = "#viewImg";
        createPop(i, t);
        const s = o[e].src
            , l = $(t).find("img");
        l.attr("src", s)
    })
}
function createPop(n, e) {
    $("body").append(n),
        $(e).on("click", function () {
            console.log("remove"),
                $(e).remove()
        })
}
export function imgDraggable() {
    const n = $("img");
    n.attr("draggable", !1)
}
function adaptHeight(n) {
    setTimeout(function (n) {
        let e = $(n)
            , t = e.eq(0).outerHeight();
        for (let n = 0; n < e.length - 1; n++)
            t < e.eq(n + 1).outerHeight() && (t = e.eq(n + 1).outerHeight());
        e.css({
            height: t + "px"
        })
    }, 500)
}
function debounce(n, e, t) {
    let o;
    return function () {
        let i = this
            , s = arguments;
        if (o && clearTimeout(o),
            t) {
            let t = !o;
            o = setTimeout(() => {
                o = null
            }
                , e),
                t && n.apply(i, s)
        } else
            o = setTimeout(() => {
                n.apply(i, s)
            }
                , e)
    }
}
export function throttle(n, e, t) {
    let o;
    if (1 === t)
        o = 0;
    else if (2 === t) { }
    return function () {
        let i = this
            , s = arguments;
        if (1 === t) {
            let t = Date.now();
            t - o > e && (n.apply(i, s),
                o = t)
        } else
            2 === t && (timeout || (timeout = setTimeout(() => {
                timeout = null,
                    n.apply(i, s)
            }
                , e)))
    }
}


